export const getCurrencySymbolAndFormat = async () => {
    try {
        const response = await fetch('https://ipapi.co/json/');
        if (!response.ok) throw new Error('API request failed');
        const data = await response.json();

        let currencyCode = data.currency || 'USD';

        const currencyLocale = getCurrencyLocale(currencyCode);
        Intl.NumberFormat.supportedLocalesOf([currencyLocale]);

        return {
            locale: currencyLocale,
            currencyCode
        }
    } catch (error) {
        return {
            locale: 'en-US', currencyCode: 'USD'
        };
    }
}


const getCurrencyLocale = (currencyCode) => {
    switch (currencyCode) {
        case 'USD':
            return 'en-US';
        case 'GBP':
            return 'en-GB';
        case 'AUD':
            return 'en-AU';
        case 'CAD':
            return 'en-CA';
        case 'INR':
            return 'en-IN';
        case 'EUR':
            return 'de-DE';
        case 'SEK':
            return 'sv-SE';
        case 'DKK':
            return 'da-DK';
        case 'NOK':
            return 'sv-SE';
        case 'CNY':
            return 'zh-CN';
        case 'TWD':
            return 'zh-TW';
        case 'KRW':
            return 'ko-KR';
        case 'BDT': //try
            return 'bn-BD';
        case 'JPY':
            return 'ja-JP';
        case 'SAR': //try
            return 'ar-SA';
        case 'TRY': //try
            return 'tr-TR';
        case 'ILS': //try
            return 'he-IL';
        case 'IRR': //try
            return 'fa-IR';
        case 'ZAR':
            return 'af-ZA';
        case 'KES': //try
            return 'sw-KE';
        case 'BRL': //try
            return 'pt-BR';
        case 'ARS': //try
            return 'es-AR';
        case 'MXN': //try
            return 'es-MX';
        case 'COP': //try
            return 'es-CO';
        case 'CHF':
            return 'fr-CH';
        case 'NZD':
            return 'en-NZ';
        case 'SGD':
            return 'en-SG';
        case 'HKD':
            return 'zh-HK';
        default:
            return 'en-US';
    }
}